import config from "src/config";
import { getData } from "src/utils/axios/serverHelper";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PRD2040_R01BomDto, PRD2040_R01MountDto } from "./Dto_PRD2040_R01";
import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";

const baseUrl = `${config.apiUrl}/PRD2040_R01`;
const productWorkUrl = `${config.apiUrl}/productWork`;

// 공정작업 목록 조회
export const getWorkList = async (params: {
    compCd?: string;
    workplaceCd?: string;
    itemCd?: string;
    workEmp?: string;
    closeTag?: string;
    startDate?: string;
    endDate?: string;
}) => {
    const queryParams = new URLSearchParams(
        Object.entries(params)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => [key, String(value)])
    );
    const url = `${productWorkUrl}/PRD2040_R01/list?${queryParams.toString()}`;
    return await getData<ResponseDto<ProductWorkDto[]>>(url);
};

// BOM 검토 조회 (공정작업번호 + 비교품목)
export const getBomCompareList = async (productWorkNo: string, mountItemCd: string) => {
    const url = `${baseUrl}/bom?productWorkNo=${productWorkNo}&mountItemCd=${mountItemCd}`;
    return await getData<ResponseDto<PRD2040_R01BomDto[]>>(url);
};

// 실장좌표 검토 조회 (공정작업번호 + 비교품목)
export const getMountPartList = async (productWorkNo: string, mountItemCd: string) => {
    const url = `${baseUrl}/mount?productWorkNo=${productWorkNo}&mountItemCd=${mountItemCd}`;
    return await getData<ResponseDto<PRD2040_R01MountDto[]>>(url);
};

// BOM 검토 엑셀
export const downloadBomExcel_PRD2040_R01 = async (productWorkNo: string, mountItemCd: string) => {
    const url = `${baseUrl}/bom/excel?productWorkNo=${productWorkNo}&mountItemCd=${mountItemCd}`;
    return await getData<ResponseDto<string | number[]>>(url);
};

// 실장좌표 검토 엑셀
export const downloadMountExcel_PRD2040_R01 = async (productWorkNo: string, mountItemCd: string) => {
    const url = `${baseUrl}/mount/excel?productWorkNo=${productWorkNo}&mountItemCd=${mountItemCd}`;
    return await getData<ResponseDto<string | number[]>>(url);
};
